import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'
import { Checkbox, CheckboxProps } from './Checkbox'

type Props = CheckboxProps & {
  control: Control
  name: string
  defaultValue?: string
}

export function ControlledCheckbox(props: Props): React.ReactElement {
  const { control, name, defaultValue, ...switchProps } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? false}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: boolean }) => (
        <Checkbox
          {...switchProps}
          name={name}
          checked={value}
          onChange={(event, newValue) => onChange(newValue)}
        />
      )}
    />
  )
}
